<script>
  import ClickOut from '../../../../utils/directives/clickout'
  export default{
    name: 'btn-edital',
    props: ['leilao', 'ACL', 'currentUser'],
    data () {
      return {
        open: false
      }
    },
    computed: {
      TIPOS_EDITAL () {
        return {
          'notificacao': 1,
          'leilao': 2
        }
      }
    },
    mounted () {},
    destroyed () {
    },
    methods: {
      toggle () {
        if (!(this.leilao.lotes || []).length) return
        const loteSemGrv = this.leilao.lotes.find(lote => !lote.grvId)
        if (loteSemGrv) {
          if (!confirm(`O lote #${loteSemGrv.numero} não possui GRV relacionada. Tem certeza?`)) return
        }
        this.open = !this.open
      },
      hide () {
        this.open = false
      }
    },
    directives: {ClickOut},
    components: {}
  }
</script>

<template>
  <div class="btn-group dropdown" :class="{ open: open}"  v-click-out="hide">
    <button class="btn btn-sm btn-black" data-toggle="dropdown" tabindex="1" aria-expanded="false" @click.stop.prevent="toggle"><i class="fa fa-file-pdf-o m-r-xs"></i> Cadastrar edital <span class="m-l-sm caret"></span></button>
    <ul class="dropdown-menu no-padder">
      <li>
        <router-link :to="{name: 'edital.novo', query: {leilao: leilao.id, tipo: TIPOS_EDITAL.notificacao}}" tabindex="2">
          <i class="fa fa-file-pdf-o fa-fw"></i> Edital de notificação
        </router-link>
      </li>
      <li>
        <router-link :to="{name: 'edital.novo', query: {leilao: leilao.id, tipo: TIPOS_EDITAL.leilao}}" tabindex="2">
          <i class="fa fa-file-pdf-o fa-fw"></i> Edital de leilão
        </router-link>
      </li>
    </ul>
  </div>
</template>



// WEBPACK FOOTER //
// BtnEdital.vue?4e0c6977